import React from "react";
import "./thankyou.css";

const Thankyou = () => {
  return (
    <div className="main global thankyou">
      <h1>Thank you</h1>
    </div>
  );
};

export default Thankyou;
